export enum Datasets {
    TTR = "TTR",
    EVAC = "EVAC",
    EVDC = "EVDC",
    HP = "HP",
    EB = "EB",
    ACU = "ACU",
    TTR_DRAFT = "TTR_DRAFT",
    EVAC_DRAFT = "EVAC_DRAFT",
    EVDC_DRAFT = "EVDC_DRAFT",
    HP_DRAFT = "HP_DRAFT",
    EB_DRAFT = "EB_DRAFT",
    ACU_DRAFT = "ACU_DRAFT",
}

export enum LCTOnlyDatasets {
    EVAC = "EVAC",
    EVDC = "EVDC",
    HP = "HP",
    EB = "EB",
    ACU = "ACU",
    EVAC_DRAFT = "EVAC_DRAFT",
    EVDC_DRAFT = "EVDC_DRAFT",
    HP_DRAFT = "HP_DRAFT",
    EB_DRAFT = "EB_DRAFT",
    ACU_DRAFT = "ACU_DRAFT",
}

// These must align with the values in the backend hybrid API codebase

export enum LimitReasons {
    voltageStatutoryLimits = "The voltage on the network must remain within statutory limits",
    furtherInformation = "A site visit is required",
    unLoopingRequired = "The property has a looped supply and therefore must be unlooped",
    cableReplacementRequired = "The service cable must be replaced",
    fuseReplacementRequired = "The fuse is not sufficient and must be replaced",
    cutOutReplacementRequired = "The cut-out is not sufficient and must be replaced",
}

export enum DnoWorksRequiredReasons {
    voltageStatutoryLimits = "The voltage on the network must remain within statutory limits",
    furtherInformation = "A site visit is required",
    unLoopingRequired = "The property has a looped supply and therefore must be unlooped",
    cableReplacementRequired = "The service cable must be replaced",
    fuseReplacementRequired = "The fuse is not sufficient and must be replaced",
    cutOutReplacementRequired = "The cut-out is not sufficient and must be replaced",
    notEnoughCapacity = "Not enough capacity on site",
    networkStudyRequired = "Network study required",
}

export enum DnoResponses {
    Approve = "DNO Approved",
    ConditionalApprove = "DNO Approved with Limit",
    furtherInformation = "Further Information Required",
    DnoWorksRequired = "DNO Works Required",
}

export enum DnoCommissioningResponses {
    Approve = "Commissioning Accepted",
    UpdateRequired = "Commissioning Update Required",
}

export enum DnoApplicationTypes {
    escalationsIncCx = "ESCALATIONS_INC_CX",
    allApprovedIncCx = "ALL_APPROVED_INC_CX",
    all = "ALL",
    allIncludingCx = "ALL_INC_CX",
    dnoWorksRequired = "DNO_WORKS_REQUIRED",
}

export enum recognisedLctDevices {
    battery = "BATTERY",
    evcpDc = "EVCP_DC",
    evcpAc = "EVCP_AC",
    v2g = "EVV2G",
    v2gInverter = "V2G_INVERTER",
    solarPvBattery = "SOLAR_PV_BATTERY",
    solarPv = "SOLAR_PV",
    hp = "HP",
    eb = "EB",
    acu = "ACU",
}

export const EscalatedReasons = [
    {
        title: "All Devices Demand Device Rating Within DNO Threshold",
        value: "allDevicesDemandDeviceRatingWithinDNOThreshold",
    },
    {
        title: "Cut Out Is Modern",
        value: "cutOutIsModern",
    },
    {
        title: "Cut Out Is In Acceptable Condition",
        value: "cutOutIsOkayCondition",
    },
    {
        title: "Devices Have No Alerts",
        value: "devicesHaveNoAlerts",
    },
    {
        title: "ENA Processing Successful",
        value: "enaProcessingSuccessful",
    },
    {
        title: "Application Not Duplicated",
        value: "isAppNotDuped",
    },
    {
        title: "Cut Out Rating Known",
        value: "isCutOutRatingKnown",
    },
    {
        title: "Cut Out Rating Within DNO Threshold",
        value: "isCutOutRatingWithinDNOThreshold",
    },
    {
        title: "Demand Equipment ENA Compliant",
        value: "isDemandEquipmentEnaCompliant",
    },
    {
        title: "Generation Capacity Within DNO Threshold",
        value: "isGenerationCapacityWithinDNOThreshold",
    },
    {
        title: "Generation Equipment ENA Compliant",
        value: "isGenerationEquipmentEnaCompliant",
    },
    {
        title: "Not On Looped Supply",
        value: "isNotOnLoopedSupply",
    },
    {
        title: "Passes Recent Demand Cluster Checks",
        value: "isPassingDemandClusterChecks",
    },
    {
        title: "Passes Recent Generation Cluster Checks",
        value: "isPassingGenerationClusterChecks",
    },
    {
        title: "Supply Is Secure",
        value: "isSupplySecure",
    },
    {
        title: "Whole Property Demand Within DNO Threshold",
        value: "isWholePropertyDemandWithinDNOThreshold",
    },
    {
        title: "Valid Cut Out Image Provided",
        value: "validCutOutImageProvided",
    },
]

export enum ApplicationStatuses {
    autoApproved = "Auto-Approved",
    escalatedToDno = "Escalated to DNO",
    dnoApproved = "DNO Approved",
    dnoApprovedWithLimit = "DNO Approved with Limit",
    dnoFurtherInfoRequired = "Further Information Required",
    dnoWorksRequired = "DNO Works Required",
    cxSubmitted = "Commissioning Submitted",
    cxAccepted = "Commissioning Accepted",
    cxUpdateRequired = "Commissioning Update Required",
}

// Strings used purely for display purposes in the UI, when different from the API value.
// e.g. Installer Information Required — API value kept as "Further Information Required" for backwards compatibility.
export enum ApplicationDisplayStatuses {
    installerInformationRequired = "Installer Information Required",
}

export enum DnoAllResovedStauses {
    autoApproved = "Auto-Approved",
    dnoApproved = "DNO Approved",
    dnoApprovedWithLimit = "DNO Approved with Limit",
    dnoFurtherInfoRequired = "Further Information Required",
    cxAccepted = "Commissioning Accepted",
    cxUpdateRequired = "Commissioning Update Required",
    reAutoApproved = "(Re) Auto-Approved",
    exMpanProvided = "Ex MPAN Provided",
}

export enum DnoEscalationStatuses {
    escalatedToDno = "Escalated to DNO",
    reEscalatedToDno = "(Re) Escalated to DNO",
    cxSubmitted = "Commissioning Submitted",
}

export enum InstallerApplicationStatuses {
    autoApproved = "Auto-Approved",
    dnoApproved = "DNO Approved",
    dnoApprovedWithLimit = "DNO Approved with Limit",
    dnoFurtherInfoRequired = "Further Information Required",
    dnoWorksRequired = "DNO Works Required",
    awaitingAssessment = "Awaiting Assessment",
    underAssessment = "Under Assessment",
    escalatedToDno = "Escalated to DNO",
    failedToLarge = "Failed - Too Large",
    failed = "Failed",
    invalidCutOut = "Failed - Invalid Cut-Out Image",
    imageScanning = "Scanning Cut-Out Image",
    imageScanFailed = "Image Scan Failed",
    cxSubmitted = "Commissioning Submitted",
    cxAccepted = "Commissioning Accepted",
    cxUpdateRequired = "Commissioning Update Required",
    reAutoApproved = "(Re) Auto-Approved",
    reEscalatedToDno = "(Re) Escalated to DNO",
    exMpanProvided = "Ex MPAN Provided",
}

export enum ExistingDeviceClasses {
    existingGenRegistered = "EXISTING_GEN_ENA_REGISTERED",
    existingDemandRegistered = "EXISTING_DEMAND_ENA_REGISTERED",
    existingGenNotRegistered = "EXISTING_GEN_NOT_REGISTERED",
    existingDemandNotRegistered = "EXISTING_DEMAND_NOT_REGISTERED",
}

export enum ProposedDeviceClasses {
    genGeneral = "GEN_DEVICE_GENERAL_ENA_REGISTERED",
    demandGeneralRegistered = "DEMAND_DEVICE_GENERAL_ENA_REGISTERED",
    demandGeneralNotRegistered = "DEMAND_DEVICE_GENERAL_NOT_REGISTERED",
    hpRegistered = "DEMAND_DEVICE_HP_ENA_REGISTERED",
    hpNotRegistered = "DEMAND_DEVICE_HP_NOT_REGISTERED",
    ebRegistered = "DEMAND_DEVICE_EB_ENA_REGISTERED",
    ebNotRegistered = "DEMAND_DEVICE_EB_NOT_REGISTERED",
    acuRegistered = "DEMAND_DEVICE_ACU_ENA_REGISTERED",
    acuNotRegistered = "DEMAND_DEVICE_ACU_NOT_REGISTERED",
}

export enum ApplicationClasses {
    genGeneral = "GENERATION_GENERAL",
    demandGeneral = "DEMAND_GENERAL",
    genDemandGeneral = "GENERATION_DEMAND_GENERAL",
}

export enum TypeTestRegion {
    greatBritain = "Great Britain",
    northernIreland = "Northern Ireland",
}

const EXISTING_IN_DATABASE = [
    ExistingDeviceClasses.existingGenRegistered,
    ExistingDeviceClasses.existingDemandRegistered,
]

const NEW_IN_DATABASE = [
    ProposedDeviceClasses.genGeneral,
    ProposedDeviceClasses.hpRegistered,
    ProposedDeviceClasses.ebRegistered,
    ProposedDeviceClasses.acuRegistered,
    ProposedDeviceClasses.demandGeneralRegistered,
]

export const NEW_AND_EXISTING_IN_DATABASE = [
    ...EXISTING_IN_DATABASE,
    ...NEW_IN_DATABASE,
]

export const VALID_DEVICE_CLASSES_FOR_ADMD_VALIDATION = [
    ProposedDeviceClasses.demandGeneralRegistered,
    ProposedDeviceClasses.demandGeneralNotRegistered,
    ProposedDeviceClasses.hpRegistered,
    ProposedDeviceClasses.hpNotRegistered,
    ProposedDeviceClasses.ebRegistered,
    ProposedDeviceClasses.ebNotRegistered,
    ProposedDeviceClasses.acuRegistered,
    ProposedDeviceClasses.acuNotRegistered,
    ExistingDeviceClasses.existingDemandRegistered,
    ExistingDeviceClasses.existingDemandNotRegistered,
]

export enum ApplicationTag {
    G98 = "G98",
    G99 = "G99",
    SGI_1 = "SGI-1",
    SGI_2 = "SGI-2",
    SGI_3 = "SGI-3",
    Demand = "Demand",
}

/** Datasets that represent Electric Boiler or Air Conditioning Unit devices */
export const EB_ACU_DATASETS = [
    Datasets.EB,
    Datasets.EB_DRAFT,
    Datasets.ACU,
    Datasets.ACU_DRAFT,
]

/**
 * HP-specific fields that are auto-set to N/A (or are otherwise irrelevant)
 * for EB and ACU devices. Matched against the API response content keys.
 */
export const EB_ACU_HIDDEN_FIELDS = [
    // HP-specific form fields auto-set to N/A
    "Function",
    "Module",
    "Module Reference",
    // HP nominal current fields (heat-pump operating points, not applicable)
    "A-7/ W35",
    "A-7/ W45",
    "A-7/ W55",
    "A-7/ W65",
    // HP-specific assessment/validation fields
    "Is Connect & Notify?",
    "Is Apply to Connect?",
    "Complies with IEC 61000-3-2 or Zpcc > Zref",
    "Complies with IEC 61000-3-3",
    "Complies with EN 61000-3-12",
    "SSC Min Three Phase (kVA)",
    "SSC Min Single Phase (kVA)",
    "Minimum Rsce calculated",
    "Fault level calculated using minimum Rsce (MVA)",
    "Impedance at PCC (Ω)",
    "Complies with EN 61000-3-11",
    "Max Impedance (Zmax)",
    // HP-specific sub-device presence flags
    "Has a back-up heater?",
    "Has a boost heater?",
    "Has a water heater?",
    "Has a heat pump?",
]

/** Section names that only exist for HP sub-devices */
export const EB_ACU_HIDDEN_SECTIONS = [
    "Back-up Heater",
    "Back-up Heater Details",
    "Boost Heater",
    "Boost Heater Details",
    "Water Heater",
    "Water Heater Details",
    "Heat Pump",
    "Heat Pump Details",
]

/**
 * Additional fields hidden for EB only — Harmonic Standards is always N/A
 * for EB (hardcoded default) so it carries no information. ACU keeps it
 * because it is user-entered.
 */
export const EB_ONLY_HIDDEN_FIELDS = ["Harmonic Standards"]

export const APPLICATION_AMENDABLE_STATUSES = [
    InstallerApplicationStatuses.autoApproved,
    InstallerApplicationStatuses.reAutoApproved,
    InstallerApplicationStatuses.dnoApproved,
    InstallerApplicationStatuses.dnoApprovedWithLimit,
    InstallerApplicationStatuses.dnoFurtherInfoRequired,
    InstallerApplicationStatuses.failed,
    InstallerApplicationStatuses.failedToLarge,
    InstallerApplicationStatuses.invalidCutOut,
    InstallerApplicationStatuses.imageScanFailed,
    InstallerApplicationStatuses.cxSubmitted,
]
